import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromMovies from './movies.reducer';

export interface State {
  movies: fromMovies.MoviesState;
}

export const reducers: ActionReducerMap<State> = {
  movies: fromMovies.moviesReducer,
};

export const selectMoviesState = createFeatureSelector<fromMovies.MoviesState>(fromMovies.inRoomMoviesFeatureKey);

export const selectMovieEntities = createSelector(selectMoviesState, fromMovies.selectMovieEntities);

export const getMovie = (movieId: string) => createSelector(selectMovieEntities, (entities) => entities[movieId]);
